module.exports = __webpack_public_path__ + "img/hockey-stick-puck.96970f6b.svg";